import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { TButtonSize } from '@cian/ui-kit/button/types';
import { IconCommunicationMessage16 } from '@cian/ui-kit-design-tokens/icons';

interface IMessageButtonProps {
  onClick: () => void;
  isHeaderButton: boolean;
  buttonSize: TButtonSize;
  children: string;
}

export const MessageButton: React.FC<IMessageButtonProps> = ({ onClick, buttonSize, isHeaderButton, children }) => {
  return (
    <Button
      beforeIcon={isHeaderButton ? <IconCommunicationMessage16 color="icon-main-default" /> : undefined}
      onClick={onClick}
      size={buttonSize}
      theme={isHeaderButton ? 'fill_secondary' : 'fill_white_primary'}
      type="button"
    >
      {children}
    </Button>
  );
};
